import { Info as InfoIcon } from '@mui/icons-material';

const Info = (): JSX.Element => <InfoIcon fontSize="inherit" />;

export default Info;
